export default "https://cdn-static.gokick.com/assets/3bfc31eca91a3170017daa7173a338c2b0e2dfbc/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";